var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevButtonSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 50,
    viewBox: "0 0 115 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1316_2649)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1316_2649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 11.5L19 21.5L29 31.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.8242 5.73438V36.7773H76.6094V5.73438H78.8242ZM62.4414 8.19531C67.0117 8.19531 70.2812 12.3789 70.2812 18.918C70.2812 25.457 67.0117 29.6406 62.4414 29.6406C57.8359 29.6406 54.6016 25.457 54.6016 18.918C54.6016 12.3789 57.8359 8.19531 62.4414 8.19531ZM62.4414 10.1641C59.1016 10.1641 56.7461 13.75 56.7461 18.918C56.7461 24.1211 59.1016 27.6719 62.4414 27.6719C65.7812 27.6719 68.1016 24.1211 68.1016 18.918C68.1016 13.75 65.7812 10.1641 62.4414 10.1641ZM110.043 5.73438V28.5156H107.828V16.3516H101.008V14.4883H107.828V5.73438H110.043ZM110.957 34.1406V36.0039H90.3555V26.4414H92.5703V34.1406H110.957ZM94.9609 12.2383C94.9609 16.3516 98.3711 20.2891 102.766 21.8008L101.605 23.5938C98.0898 22.293 95.2246 19.5859 93.9062 16.2461C92.5879 19.9902 89.5293 22.9434 85.8555 24.3672L84.6953 22.5391C89.125 20.957 92.7461 16.8438 92.7461 12.2383V10.3047H85.4688V8.40625H102.133V10.3047H94.9609V12.2383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1316_2649",
    x: 0,
    y: 0,
    width: 116,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1316_2649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1316_2649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1316_2649",
    x: 14,
    y: 10.5,
    width: 20,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1316_2649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1316_2649",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevButtonSvg);
export default __webpack_public_path__ + "static/media/PrevButtonSVG.305116086e7be2ca339db1a497c65ea4.svg";
export { ForwardRef as ReactComponent };